import React, { useState } from 'react';
import './MuseoPage.css';

import { PageTitle, Heading } from '../../../components'; 
import { FaArrowRight, FaPlus } from 'react-icons/fa';
import { useParams } from 'react-router-dom';

import { museoData } from '../../../constants';

import Lightbox from "react-18-image-lightbox";
import "react-18-image-lightbox/style.css";

const MuseoPage = () => {

    const { id } = useParams();
    const pageData = id
        ? museoData.find(item => item.id.toString() === id)
        : museoData[0];

    // --- LOGIKA GALERII (LIGHTBOX) ---
    const [index, setIndex] = useState(-1);
    
    const galleryImages = pageData?.gallery || [];

    const currentImage = galleryImages[index];
    const nextIndex = (index + 1) % galleryImages.length;
    const nextImage = galleryImages[nextIndex] || currentImage;
    const prevIndex = (index + galleryImages.length - 1) % galleryImages.length;
    const prevImage = galleryImages[prevIndex] || currentImage;

    const openLightbox = (i) => setIndex(i);
    const closeLightbox = () => setIndex(-1);
    const handleMovePrev = () => setIndex(prevIndex);
    const handleMoveNext = () => setIndex(nextIndex);
    // ----------------------------------

    if (!pageData) {
        return (
            <div style={{ padding: '100px', textAlign: 'center' }}>
                <h2>Nie znaleziono danych.</h2>
            </div>
        );
    }

    return (
        <>
            <PageTitle title={pageData.title} page={'Muzeum'} />

            <section className='event-single page-single'>

                <div className='event-info page-info'>

                    {/* Główne zdjęcie artykułu */}
                    <div className='image'>
                        {pageData.image && <img src={pageData.image} alt={pageData.title} />}
                    </div>

                    <div className='content'>

                        <h3 className='main-heading'>{pageData.title}</h3>

                        {pageData.paragraphs && pageData.paragraphs.map((paragraph, index) => (
                            <p key={index} style={{ marginBottom: '15px' }}>
                                {paragraph}
                            </p>
                        ))}

                        {pageData.agenda && (
                            <div className='sub-section'>
                                <h3 className='sub-heading'>Zbiórka eksponatów</h3>

                                {pageData.agenda.intro && (
                                    <p style={{ fontWeight: 'bold', marginBottom: '1rem' }}>
                                        {pageData.agenda.intro}:
                                    </p>
                                )}

                                {pageData.agenda.points && (
                                    <ul className='custom-list'>
                                        {pageData.agenda.points.map((point, index) => (
                                            <li key={index} style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '10px' }}>
                                                <FaArrowRight className='icon' style={{ color: 'var(--main-color)', flexShrink: 0 }} />
                                                <span>{point}</span>
                                            </li>
                                        ))}
                                    </ul>
                                )}

                                {pageData.agenda.end && (
                                    <p style={{ fontWeight: 'bold', marginBottom: '1rem' }}>
                                        {pageData.agenda.end}
                                    </p>
                                )}
                            </div>
                        )}
                    </div>
                </div>

                {/* --- SEKCJA GALERII EKSPONATÓW --- */}
                {galleryImages.length > 0 && (
                    <div className="museo-gallery-section">
                        
                        {/* Wyśrodkowany nagłówek */}
                        <div style={{ textAlign: 'center', marginBottom: '3rem' }}>
                            <Heading title={'Galeria'} subTitle={'Zobacz nasze eksponaty'} />
                        </div>

                        <div className='museo-gallery-grid'>
                            {galleryImages.map((item, i) => {
                                return (
                                    <div key={i} className={`museo-gallery-item`}>
                                        <img src={item} alt={`Eksponat ${i + 1}`} />
                                        <div className="museo-gallery-overlay">
                                            <button onClick={() => openLightbox(i)}>
                                                <FaPlus className='museo-gallery-icon' />
                                            </button>
                                        </div>
                                    </div>
                                );
                            })}
                        </div>

                        {index !== -1 && (
                            <Lightbox
                                mainSrc={currentImage}
                                mainSrcThumbnail={currentImage}
                                nextSrc={nextImage}
                                nextSrcThumbnail={nextImage}
                                prevSrc={prevImage}
                                prevSrcThumbnail={prevImage}
                                onCloseRequest={closeLightbox}
                                onMovePrevRequest={handleMovePrev}
                                onMoveNextRequest={handleMoveNext}
                            />
                        )}
                    </div>
                )}
                {/* ---------------------------------- */}

            </section>
        </>
    );
}

export default MuseoPage;